import './index.css';
import App from './App';
import ReactDOM from 'react-dom/client';
import { parseCustomUrlParams, validateAutonocogBlank } from './utils/validation';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Save the initial results to local storage
const results = JSON.parse(localStorage.getItem("results")) || {};
localStorage.setItem("results", JSON.stringify(results));
const userData = parseCustomUrlParams();

// Use async/await to wait for the result of validateAutonocogBlank
const checkValidationAndRenderApp = async (dev = true) => {
  try {
    const validity = await validateAutonocogBlank(userData.UUID, userData.origin, userData.attemptNumber);
    console.log('Validity of URL:', validity);
    
    if (dev === true || validity === false) {// Render the App if validity is false
        console.log('Access permitted.');
        root.render(<App userData={userData} />);
      } else if (validity === null) { // Handle the null case, possibly an error or unable to validate
        console.log('Validation error or unable to validate.');
        root.render(<div>Unable to validate link. Please try again later.</div>);
      } else {  // If validity is true, render Access Denied
        console.log('Access denied.');
        root.render(<div>Access Denied</div>);
      }
    } catch (error) { // Handle any unexpected errors
      console.error('Unexpected error:', error);
      root.render(<div>Unexpected Error: {error.message}</div>);
    }
};

// Call the async function to check validation and render App
checkValidationAndRenderApp();